import i18next from 'i18next'

/**
 * Allows you to make an object's property language-aware.
 * Whenever the given property is read, the callback will be executed with the original value and the current language as arguments
 * @param {Object} object object which contains a property that should be language-aware
 * @param {string} property property name of the object
 * @param {function} callback callback which returns the language-specific value.
 */
export default async function makeLanguageAware(object, property, callback) {
    await i18next
    const privatePropertyName = `__${property}`
    if (privatePropertyName in object) {
        console.warn(
            `Property "${property}" is already language-aware! Please make sure to only call makeLanguageAware once.`
        )
        return
    }
    Object.defineProperty(object, privatePropertyName, {
        value: object[property],
        writable: false,
    })
    Object.defineProperty(object, property, {
        get: () => {
            return callback(
                object[privatePropertyName],
                i18next.language,
                i18next.t
            )
        },
    })
}

export function getCookie(name) {
    const cookieValue = document.cookie
        .split(';')
        .map(cookie => cookie.trim())
        .filter(cookie => cookie.startsWith(name + '='))
        .map(cookie => cookie.substring(name.length + 1))

    return cookieValue ? decodeURIComponent(cookieValue) : false
}
